import React, { useState, useContext, useEffect } from 'react';
import Header from '../../components/Common/Header/Header';
import { useTranslation } from 'react-i18next';
import ContentApp from '../../components/ContentApp';
import { getQueryString } from '../../helpers/url';
import BoxShareLink from '../../components/BoxShareLink/BoxShareLink';
import { WelletContext } from '../../context/WelletContext';
import { CircleSpinner } from 'react-spinners-kit';

const ReferralLink = () => {
  const { t } = useTranslation();
  const link = getQueryString('link');
  const showName = getQueryString('showName');
  const showCity = getQueryString('showCity');
  const showId = getQueryString('showId');
  const commissionPercentage = getQueryString('commissionPercentage');

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: showName,
          url: link,
        });
      } else {
        console.warn('Web Share API not supported in this browser.');
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  return (
    <>
      <Header pathName={`/venue`} pathSearch={'?showId=' + showId} />

      <ContentApp classes='pb-0'>
        <>
          <div className='pb-3 mb-3' style={{ borderBottom: '1px solid #3d3d3d' }}>
            <h1 className='font-large m-0'>{showName}</h1>
            <div className='text-secondary mt-1'>{showCity}</div>
          </div>
          <div className='font-125 text-tertiary fw-700'>{t('shareActivity')}</div>
          <div className='font-small text-secondary'>{t('shareActivityDescription')}</div>

          <div className='fw-700 text-primary font-tiny mt-4 mb-3'>{t('personalLinkBooking')}</div>
          <div>
            <BoxShareLink link={link} shareButtonText={t('share')} onShareClick={handleShare} />
          </div>
          <div
            className='text-center mt-5 p-2'
            style={{ border: '1px solid #1D9BF0', borderRadius: '5px' }}
          >
            <div className='font-small text-primary fw-600'>
              {t('earnSomeoneBuysLink', { commission: commissionPercentage })}
            </div>
          </div>
        </>
      </ContentApp>
    </>
  );
};

export default ReferralLink;
